// Header.js
import React from 'react';
import { Link } from 'react-router-dom';

// ⬇️ Import the logo once
import SaigeLogo from '../images/SAIGE_TextLogo.png';

const Header = () => {
  return (
    <header id="page-topbar">
      <div className="navbar-header d-flex align-items-center justify-content-between">
        {/* Logo */}
        <div className="navbar-brand-box">
          {/* Dark theme logo */}
          <Link to="/dashboard" className="logo logo-dark">
            <span className="logo-sm">
              {/* “Small” variant (22 px high) */}
              <img src={SaigeLogo} alt="SAIGE logo" height="22" />
            </span>
            <span className="logo-lg">
              {/* “Large” variant (20 px high) */}
              <img src={SaigeLogo} alt="SAIGE logo" height="20" />
            </span>
          </Link>

          {/* Light theme logo (re‑use the same image) */}
          <Link to="/dashboard" className="logo logo-light">
            <span className="logo-sm">
              <img src={SaigeLogo} alt="SAIGE logo" height="22" />
            </span>
            <span className="logo-lg">
              <img src={SaigeLogo} alt="SAIGE logo" height="20" />
            </span>
          </Link>
        </div>

        {/* Navbar items (right side) */}
        <div className="d-flex">
          {/* User dropdown */}
          <div className="dropdown d-inline-block">
            <button
              type="button"
              className="btn header-item"
              id="page-header-user-dropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="d-none d-xl-inline-block ms-1">User</span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </button>

            <div className="dropdown-menu dropdown-menu-end">
              <Link to="/logout" className="dropdown-item">
                <i className="mdi mdi-logout font-size-16 align-middle me-1"></i> Logout
              </Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

